import React, { useEffect, useState } from "react";
import { Clock } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function SessionWarning({ open, seconds, onStay }) {
  const [left, setLeft] = useState(seconds);

  useEffect(() => {
    if (!open) return;
    setLeft(seconds);
    const t = setInterval(() => setLeft((s) => (s > 0 ? s - 1 : 0)), 1000);
    return () => clearInterval(t);
  }, [open, seconds]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-slate-900/50 backdrop-blur-sm flex items-end sm:items-center justify-center p-4" data-testid="session-warning">
      <div className="w-full max-w-sm rounded-xl bg-white p-6 shadow-xl border border-slate-200">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-lg bg-amber-100 flex items-center justify-center shrink-0">
            <Clock className="h-5 w-5 text-amber-600" weight="bold" />
          </div>
          <div>
            <h2 className="font-semibold text-slate-900">Still there?</h2>
            <p className="text-sm text-slate-500">You'll be signed out for inactivity.</p>
          </div>
        </div>
        <div className="mt-5 text-center">
          <div className="text-4xl font-bold text-slate-900 tabular-nums" data-testid="session-countdown">{left}s</div>
          <p className="text-xs text-slate-400 mt-1">Any unsaved entry will be lost.</p>
        </div>
        <Button onClick={onStay} className="w-full mt-5 bg-blue-600 hover:bg-blue-700" data-testid="session-stay-btn">
          Stay signed in
        </Button>
      </div>
    </div>
  );
}
